import { HeartHandshake, Send } from 'lucide-react';
import type { NavigatorCategory } from './navigator-results.types';
import type { NavigatorResultsCopy } from './navigatorResultsCopy';

type NavigatorConciergeEmptyStateProps = {
  copy: NavigatorResultsCopy;
  category: NavigatorCategory;
  onConciergeRequest?: (category: NavigatorCategory) => void;
};

/**
 * Empty category = Care Concierge handoff, not a dead end: prototype message
 * + the banner's amber CTA (rendered only when a handler is wired).
 */
export const NavigatorConciergeEmptyState = ({
  copy,
  category,
  onConciergeRequest,
}: NavigatorConciergeEmptyStateProps) => (
  <div className="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-border-subtle bg-card-subtle p-8 text-center">
    <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-sage-bg text-sage">
      <HeartHandshake className="h-5 w-5" aria-hidden />
    </span>
    <p className="max-w-xl text-sm leading-relaxed text-text-secondary">
      {copy.noProvidersConciergeMessage}
    </p>
    {onConciergeRequest && (
      <button
        type="button"
        onClick={() => onConciergeRequest(category)}
        className="inline-flex h-10 items-center gap-2 rounded-full bg-[hsl(40_85%_60%)] px-5 text-sm font-semibold text-[hsl(35_55%_18%)] transition-colors duration-150 ease-out hover:bg-[hsl(40_85%_52%)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-emphasis"
      >
        <Send className="h-4 w-4" aria-hidden />
        {copy.conciergeCtaLabel}
      </button>
    )}
  </div>
);
